import { render, staticRenderFns } from "./DashUniversitiesList.vue?vue&type=template&id=e3e3c2c6&scoped=true&"
import script from "./DashUniversitiesList.vue?vue&type=script&lang=js&"
export * from "./DashUniversitiesList.vue?vue&type=script&lang=js&"
import style0 from "./DashUniversitiesList.vue?vue&type=style&index=0&id=e3e3c2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e3c2c6",
  null
  
)

export default component.exports